import { useRef } from 'react';
import { DatePicker } from 'antd';
import { useIntl } from 'react-intl';
import classnames from 'classnames';

import { isUserAuthorized } from 'utils/helpers';
import { ACL_MATRIX } from 'common/permissions';
import { exportBusinessAnalyticsInfo } from 'services/business';

import BRButton from 'components/BRButton/BRButton';
import { notify } from 'components/Notify/Notify';

import { ReactComponent as Download } from 'assets/bosta-icons/Download.svg';
import { ReactComponent as Shop } from 'assets/bosta-icons/Shop.svg';
import { ReactComponent as CircleCheck } from 'assets/bosta-icons/Circle-Check.svg';

import './BusinessHeader.less';

const BusinessHeader = ({
  businessData,
  dateValue,
  setDateValue,
  setIsLoading,
  ...props
}) => {
  const { formatMessage } = useIntl();
  const datePickerRef = useRef();

  const {
    _id: businessId,
    name,
    businessTier,
    pricingTier,
    insurancePlan,
    status,
    isFirstTimeExceptionApplied
  } = businessData || {};

  const handleFocus = () => {
    datePickerRef.current?.focus?.();
  };
  const onChangeDate = (date) => {
    if (!date) {
      setDateValue(null);
      handleFocus();
      return;
    }
    setDateValue(date);
  };

  const handleExportBusinessAnalytics = async () => {
    if (!businessId || !dateValue) return;

    setIsLoading(true);

    try {
      const { data } = await exportBusinessAnalyticsInfo({
        businessId,
        date: dateValue.format('YYYY-MM-DD')
      });

      notify(data, 'success');
    } catch (error) {
      notify(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="br-business-header">
      <div className="br-business-header__left">
        <span className="br-business-header__icon">
          <Shop />
        </span>
        <div className="br-business-header__left-info">
          <div className="br-business-header__left-info-title">
            <span className="display-xs">{name}</span>

            <div className="br-business-header__left-info-title-status">
              <CircleCheck className="br-business-header__left-info-check-icon" />
              <span className="">{status}</span>
            </div>
          </div>

          <div className="br-business-header__left-info-subtitle">
            <div className="br-business-header__left-info-subtitle-details">
              <span>{businessTier} </span> - <span>{pricingTier?.name} </span>|
              <span>{insurancePlan?.name}</span>
            </div>
            {!!isFirstTimeExceptionApplied && (
              <span className="br-business-header__left-info-subtitle-first-exception caption">
                {formatMessage({
                  id: 'merchant_analysis.first_time_exception'
                })}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="br-business-header__actions">
        <DatePicker
          ref={datePickerRef}
          onChange={onChangeDate}
          picker="month"
          format={'YYYY, MMM'}
          allowClear
          className={classnames('br-business-header__actions-date-picker', {
            'date-selected': !!dateValue
          })}
          value={dateValue}
        />
        {isUserAuthorized([], [ACL_MATRIX.BUSINESS_ANALYTICS_EXPORT]) && (
          <BRButton
            type={'basic'}
            onClick={handleExportBusinessAnalytics}
            label={formatMessage({ id: 'common.export' })}
            prefixIcon={<Download />}
            disabled={!businessId || !dateValue}
          />
        )}
      </div>
    </div>
  );
};

export default BusinessHeader;
